<div class="modal-backdrop" (click)="onBackdropClick()"></div>
<dialog #dialogElement class="native-dialog" [open]="true">
  <div class="dialog-container">
    @if (config().title || config().icon) {
      <div class="dialog-header">
        @if (config().icon) {
          <div class="dialog-icon">
            <mat-icon [style.color]="config().iconColor || '#1976d2'">{{ config().icon }}</mat-icon>
          </div>
        }
        @if (config().title) {
          <h2>{{ config().title }}</h2>
        }
      </div>
    }

    <div class="dialog-content">
      @if (config().message) {
        <p>{{ config().message }}</p>
      }
    </div>

    <div class="dialog-actions">
      @for (action of config().actions; track action) {
        <button
          mat-button
          [color]="action.color || 'primary'"
          [attr.mat-raised-button]="action.variant === 'raised' ? '' : null"
          [attr.mat-stroked-button]="action.variant === 'stroked' ? '' : null"
          [attr.mat-flat-button]="action.variant === 'flat' ? '' : null"
          (click)="onActionClick(action.action)">
          {{ action.text }}
        </button>
      }
    </div>
  </div>
</dialog>
